export default "__VITE_ASSET__CZg$rvO5__"